import '../reset.css';
import '../style.css';
import './_common/my_sentry.js';
import {getSurveySlugFromSearch} from './_surveys_helpers.js';
import {createSurveyIn} from './_surveys_runtime.js';

document.addEventListener('DOMContentLoaded', () => {
  const pageTitle = document.getElementById('survey-page-title');
  const pageStatus = document.getElementById('survey-page-status');
  const prefixContainer = document.getElementById('survey-prefix');
  const formContainer = document.getElementById('survey-form');
  const slug = getSurveySlugFromSearch(window.location.search);

  void createSurveyIn(formContainer, slug, {
    titleNode: pageTitle,
    statusContainer: pageStatus,
    prefixContainer,
  });
});
